import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { filter, map, tap } from 'rxjs';
import { ActivateBreadcrumb, BreadcrumbActionTypes, GoBack } from '../actions/breadcrumb.actions';
import { breadcrumbs } from '../reducer/breadcrumb.reducer';

@Injectable()
export class BreadcrumbEffects {
    activateBreadcrumb$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(ActivateBreadcrumb),
                tap(({ breadcrumb }) => {
                    if (typeof breadcrumb.onClick === 'function') {
                        breadcrumb.onClick();
                    } else if (typeof breadcrumb.onClick === 'string') {
                        this.router.navigate([breadcrumb.onClick]);
                    }
                })
            ),
        { dispatch: false }
    );

    goBack$ = createEffect(() =>
        this.actions$.pipe(
            ofType(GoBack),
            concatLatestFrom(() => this.store.select(breadcrumbs)),
            filter(([, breadcrumbs]) => breadcrumbs && breadcrumbs.length >= 2),
            map(([, breadcrumbs]) => ({ type: BreadcrumbActionTypes.ActivateBreadcrumb, breadcrumb: breadcrumbs[breadcrumbs.length - 2] }))
        )
    );

    constructor(
        private actions$: Actions,
        private router: Router,
        private store: Store
    ) {}
}
